import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "drawer-title" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  src: "https://static-s.theckb.com/BusinessMarket/Client/choice/error_icon.png",
  alt: ""
}, null, -1)
const _hoisted_3 = { class: "drawer-content" }
const _hoisted_4 = { class: "fee-detail" }
const _hoisted_5 = { class: "fee-detail-title" }
const _hoisted_6 = { class: "fee-detail-total" }
const _hoisted_7 = { class: "total-item" }
const _hoisted_8 = { class: "title" }
const _hoisted_9 = { class: "text" }
const _hoisted_10 = { class: "total-item" }
const _hoisted_11 = { class: "title" }
const _hoisted_12 = { class: "text" }
const _hoisted_13 = {
  key: 0,
  class: "main-price"
}
const _hoisted_14 = { class: "total-item" }
const _hoisted_15 = { class: "title" }
const _hoisted_16 = { class: "text" }
const _hoisted_17 = { style: {"color":"#FE2C55","font-weight":"500"} }

import { formatMoney } from '@/plugins/utils'
import { t } from '@/plugins/i18n'
import { ref, computed, onMounted } from 'vue'
import PayContent from './payContent.vue'
import { allIncludeExchangeRate } from '@/util/useYan'
import bus from '@/util/useBus'
import { useSite2Station } from '@/store'
import { getCustomerWalletList } from '@/apis/fund'

export default /*#__PURE__*/_defineComponent({
  props: ['choiceTotalAmount', 'shopWallet'],
  emits: ['success'],
  setup(__props, { expose, emit: emits }) {

const props = __props
const s = '主账户可用余额：JPY A CNY B,可转账至子店铺'



const visible = ref(false)
const open = () => {
  visible.value = true
}
const remainingPrice = computed(() => {
  const cny = (props.choiceTotalAmount?.totalAmtCn - props.shopWallet).toFixed(2)
  // 日元金额相减
  const jpy = props.choiceTotalAmount.totalAmt - Math.floor(props.shopWallet * allIncludeExchangeRate.value)
  return {
    cny,
    jpy,
    shopWallet: props.shopWallet,
    shopWalletJPY: Math.floor(props.shopWallet * allIncludeExchangeRate.value)
  }
})
expose({
  open
})
const paySuccess = () => {
  visible.value = false
  emits('success')
  bus.emit('shopPaySuccess')
}
const mainWalletInfo: any = ref({})
onMounted(() => {
  getCustomerWalletList({
    stationCode: useSite2Station(),
    currencyCode: 'CNY'
  }).then((res: any) => {
    const { data } = res
    mainWalletInfo.value = data.find?.((e: any) => e.accountType === 1)
  })
})

return (_ctx: any,_cache: any) => {
  const _component_el_drawer = _resolveComponent("el-drawer")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_drawer, {
      modelValue: visible.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((visible).value = $event)),
      direction: "btt",
      "custom-class": "shopcart-recharge-drawer"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("span", null, _toDisplayString(_unref(t)('余额不足')), 1)
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(t)('费用明细')), 1),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(t)('订单总价')) + ":", 1),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("span", null, "JPY" + _toDisplayString(_unref(formatMoney)(__props.choiceTotalAmount.totalAmt)), 1),
                  _createElementVNode("span", null, "CNY" + _toDisplayString(_unref(formatMoney)(__props.choiceTotalAmount.totalAmtCn.toFixed(2))), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("span", _hoisted_11, _toDisplayString(_unref(t)('子账户余额可支付')) + ":", 1),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("span", null, "JPY" + _toDisplayString(_unref(formatMoney)(Math.floor(__props.shopWallet * _unref(allIncludeExchangeRate)))), 1),
                  _createElementVNode("span", null, "CNY" + _toDisplayString(_unref(formatMoney)(__props.shopWallet)), 1),
                  (mainWalletInfo.value.availableAmount > 0)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_13, "(" + _toDisplayString(_unref(t)(s).replace('A',
                  _unref(formatMoney)(Math.floor(mainWalletInfo.value.availableAmount *
                    _unref(allIncludeExchangeRate)))).replace('B', _unref(formatMoney)(mainWalletInfo.value.availableAmount))) + ")", 1))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("span", _hoisted_15, _toDisplayString(_unref(t)('剩余需支付')) + ":", 1),
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("span", _hoisted_17, "JPY" + _toDisplayString(_unref(formatMoney)(_unref(remainingPrice).jpy)), 1),
                  _createElementVNode("span", null, "CNY" + _toDisplayString(_unref(formatMoney)(_unref(remainingPrice).cny)), 1)
                ])
              ])
            ])
          ])
        ]),
        _createVNode(PayContent, {
          remainingPrice: _unref(remainingPrice),
          onSuccess: paySuccess
        }, null, 8, ["remainingPrice"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})